import $ from 'jquery'
import 'jquery-migrate'
import './modules/_skip-link-focus-fix'
import './modules/_foundation-scripts'
import './modules/_carousels'
import 'superfish'
import Mmenu from 'mmenu-js'
import 'jquery-match-height'
import 'stacktable.js'
import 'remodal'
import Cookies from 'js-cookie'

import { detect } from 'detect-browser'

/**
 * Notes:
 *
 * Although jQuery is imported above, it is not bundled
 * with the transpiled assets. jQuery needs to be global
 * on the website.
 *
 * All imports belong at the top of the file.
 *
 * Webpack only outputs this one script file, if you need
 * another file then add it to the scripts-list.js file as
 * another line in the scripts_list object.
 *
 * The scripts_list const is imported into the webpack
 * config. I've done this so that you do not have to
 * wade through the config to find what is being
 * compiled out as its own file.
 *
 * When importing node modules that are not ES6 modules,
 * you do not need to path them as '../../node_modules/'.
 * Gulp knows about the node_modules directory, so all you need
 * to do is path them as if you were already in the node_modules
 * directory
 *
 * Instead of:
 * import '../../node_modules/jquery-migrate/dist/jquery-migrate';
 *
 * Use:
 * import 'jquery-migrate/dist/jquery-migrate';
 *
 */

$('.print-control').click(function (event) {
	event.preventDefault()
	window.print()
})

/*************** Template part region toggle button ***************/
$('#theme_debug_regions').on('click', function (event) {
	event.preventDefault()

	$('.placeHolderPosition').slideToggle()
})

/*************** Match Height ***************/
$('.match-height').matchHeight()

$('.pricing-table').stackcolumns()

/*************** Browser Version ***************/
const browser = detect()
const browser_version = browser.version.split('.')
const browser_html_class = browser.name + '-' + browser_version[0]

$('html').addClass(browser_html_class)

// Desktop Menu
const main_menu = $('#site_main_menu_js')

$.each(main_menu.find('> li'), function (index, item) {
	// If top level nav item add class top-level
	// to be used later to figure out what is a
	// top level item
	$(item).addClass('top-level')
})

main_menu
	.superfish({
		delay: 500,
		speed: 100,
		onShow: function () {
			const dropdown = $(this)
			const offset = dropdown.offset()
			const left = offset.left
			const width = dropdown.width()
			const docWidth = $(window).width()

			if (!width) return

			const isEntirelyVisible = left + width <= docWidth

			if (!isEntirelyVisible) {
				dropdown.addClass('out-of-bounds')
			}
		},
	})
	.show()

// Mobile Menu
document.addEventListener('DOMContentLoaded', () => {
	const menu = new Mmenu('#mobile_menu_js', {
		counters: {
			add: true,
		},
		extensions: ['pagedim-black'],
	})

	const api = menu.API

	document.getElementById('main_menu_toggle_js').addEventListener('click', event => {
		event.preventDefault()

		api.open()
	})

	$('#mobile_menu_js').removeClass('hidden')
})

/*************** Site Search ***************/
$('#site_search').on('click', function (event) {
	event.preventDefault()

	if ($('.site-search-form').hasClass('site-search-form--active')) {
		$('.site-search-form').removeClass('site-search-form--active')
		$('#site_search').trigger('focus')
	} else {
		$('.site-search-form').addClass('site-search-form--active')
		$('#site_search_field').trigger('focus')
	}
})

$('#site_search_mobile').on('click', function (event) {
	event.preventDefault()

	if ($('.site-search-form-mobile').hasClass('site-search-form--active')) {
		$('.site-search-form-mobile').removeClass('site-search-form--active')
		$('#site_search').trigger('focus')
	} else {
		$('.site-search-form-mobile').addClass('site-search-form--active')
		$('#site_search_field').trigger('focus')
	}
})

/*************** login modal ***************/

$('.personal-login a').on('click', function () {
	$('#personal-login').foundation('open')
})

$('.business-login a').on('click', function () {
	$('#business-login').foundation('open')
})

/*************** External site notice ***************/
const allowedDomains = [
	'web9.secureinternetbank.com',
	'www.cnbanktx.com',
	'www.txn.bank',
	'www.netteller.com',
	'netteller.com',
	'cm.netteller.com',
	'www.myhnb.com',
	'localhost',
	'txn.local',
	'wordpress-326963-2464313.cloudwaysapps.com',
	'txn-bank.local',
]

if (!$('body').hasClass('page-id-141')) {
	$('a').on('click', function () {
		if (this.hostname && allowedDomains.includes(this.hostname)) return true
		if ($(this).attr('role') === 'tab') return true
		let href = $(this).attr('href')
		if (href && href.indexOf('tel:') === 0) return true

		const notice = window.confirm(
			'You are leaving the TXN Bank’s website and will be redirected to another site. TXN Bank makes no endorsements or claims about the accuracy or content of the information contained in these sites. The security and privacy policies on these sites may be different from those of TXN Bank.'
		)

		let value = false
		value = notice ? true : false

		return value
	})
}

/*************** Open modal Window ***************/
var inst = $('[data-remodal-id=alert-notice-modal]').remodal({
	// hashTracking: true,
	// closeOnOutsideClick: false,
})

/**
 * Opens the modal window
 */
if (!Cookies.get('alert-notice-modal')) {
	if (inst) {
		inst.open()
	}
}

$(document).on('closed', '.alert-notice-modal', function () {
	Cookies.set('alert-notice-modal', 'closed', { expires: 1, path: '/' })
})

/**** Modal for external links on /txn-resources/wealth-management/ page id 141 ****/

if ($('body').hasClass('page-id-141')) {
	let originalLink

	// Listen for clicks on external links from ameriprise or www.ameriprise domain
	$('a[href^="http"]')
		.filter(function () {
			return this.hostname.startsWith('ameriprise') || this.hostname.startsWith('www.ameriprise')
		})
		.on('click', function (e) {
			e.preventDefault()
			originalLink = $(this).attr('href')
			$('#external-link-modal').foundation('open')
		})

	// Handle all links within modal-content
	$('#external-link-modal .modal-content a').on('click', function (e) {
		e.stopPropagation()
		e.preventDefault()
		window.location.href = this.href
	})

	// Handle modal buttons
	$('#external-link-modal').on('click', function (e) {
		if ($(e.target).is('button[data-link]')) {
			e.preventDefault()
			$('#external-link-modal').foundation('close')
			setTimeout(() => (window.location.href = originalLink), 1000)
		} else if ($(e.target).is('button[data-reveal-close]')) {
			$('#external-link-modal').foundation('close')
		}
	})
}
